import React, { useEffect, useState } from 'react';
import DataTable from '../common/DataTable';
import { numOfPage, ShippedLabelHistoryColumns } from '../../constant';
import { useDispatch, useSelector } from 'react-redux';
import BatchPagination from '../batch/BatchPagination';
import { getShippedLabelHistory, updatePickedItemStatus } from '../../store/actions/picker.action';
import moment from 'moment';
import DatePickerComponent from "../common/DatePickerComponent";
import LoaderSpinner from '../common/Loader';
import _ from 'lodash';
import { toast } from "react-toastify";
import { commaSeparatedStringToArray } from '../../config/utils';
import CollapsibleGroupedTable from '../common/CollapsibleTable';

/*istanbul ignore next */
const ShippedLabelHistory = () => {
    let dispatch = useDispatch();
    const [loader, setLoader] = useState(false);
    const [packingLabels, setPackingLabels] = useState([]);
    const { shippedLabelHistoryStatus, shippedLabelHistory } = useSelector((state) => state.pickerReducer);

    let dataLoad = {
        pageIndex: 1,
        pageSize: 30,
        sortColumn: '',
        sortOrder: 'ASCENDING',
        searchkey: '',
        startDate: moment().format('YYYY-MM-DDT00:00:00'),
        endDate: moment().format('YYYY-MM-DDT00:00:00'),
    }
    const [filterData, setfilterData] = useState(dataLoad);

    const handleAction = async (item, type) => {
        let data = commaSeparatedStringToArray(item.OutbounditemIdList);
        let payloadData = {
            commaSeparatedIds: item.OutbounditemIdList
        }
        if (data.length) {
            let updateRes = await updatePickedItemStatus(payloadData);
            if (updateRes?.data?.Status === 200) {
                toast.success('Status Updated Successfully');
                fetchAllList();
            }
        } else {
            toast.error('Failed to update status');
        }
    };

    const handleSortingColumn = (key) => {
        let newSortOrder = filterData.sortOrder === "ASCENDING" ? "DESCENDING" : "ASCENDING";
        setfilterData({
            ...filterData,
            sortColumn: key,
            sortOrder: newSortOrder,
        });
    };

    useEffect(() => {
        if (shippedLabelHistoryStatus === 'PENDING') {
            setLoader(true);
        } else if (shippedLabelHistoryStatus === 'SUCCESS') {
            setLoader(false);
        }
    }, [shippedLabelHistoryStatus]);

    useEffect(() => {
        fetchAllList();
    }, [filterData.numberOfPage, filterData.pageIndex, filterData.pageSize, filterData.sortColumn, filterData.sortOrder]);

    const fetchAllList = () => {
        let payload = {
            ...filterData,
            startDate: moment(filterData.startDate).format('YYYY-MM-DD'),
            endDate: moment(filterData.endDate).format('YYYY-MM-DD')
        };
        dispatch(getShippedLabelHistory(payload));
    }

    const handleDateChange = (date) => {
        let dateFormat = moment(date).format('YYYY-MM-DDT00:00:00');
        let dataLoad = {
            ...filterData,
            startDate: dateFormat,
            endDate: dateFormat
        }
        setfilterData(dataLoad);
        let payload = {
            ...dataLoad,
            startDate: moment(date).format('YYYY-MM-DD'),
            endDate: moment(date).format('YYYY-MM-DD')
        }
        dispatch(getShippedLabelHistory(payload));
    }

    useEffect(() => {
        if (shippedLabelHistory?.shippedLabelHistory) {
            let addlistIndex = shippedLabelHistory.shippedLabelHistory.map((item, index) => ({
                ...item,
                listIndex: index,
                isChecked: false,
            }));
            setPackingLabels(addlistIndex);
            if (shippedLabelHistoryStatus === 'success') {
                setfilterData({
                    ...filterData,
                    totalPages: Math.ceil(shippedLabelHistory?.TotalRecords / filterData.pageSize),
                });
            }
        }
    }, [shippedLabelHistory]);

    const handleCheckRecord = (e, type) => {
        const { checked } = e.target;
        let recordData = [...packingLabels];
        if (_.isEmpty(type)) {
            if (checked) {
                let markCheck = recordData.map((item) => ({
                    ...item,
                    isChecked: true,
                }));
                setPackingLabels(markCheck);

            } else {
                let markCheck = recordData.map((item) => ({
                    ...item,
                    isChecked: false,
                }));
                setPackingLabels(markCheck);
            }
        } else {
            recordData[type.listIndex].isChecked = checked;
            setPackingLabels(recordData);
        }
    };

    const handleMultiUpdate = async () => {
        let checkedData = packingLabels.filter((item) => {
            if (item?.isChecked) {
                return item;
            }
        });
        if (checkedData.length) {
            const outboundIds = checkedData.map(item => item.OutbounditemIdList).join(',');
            let payloadData = {
                commaSeparatedIds: outboundIds
            }
            let updateRes = await updatePickedItemStatus(payloadData);
            if (updateRes?.data?.Status === 200) {
                toast.success('Status Updated Successfully');
                fetchAllList();
            }
        } else {
            toast.error('Failed to update status');
        }
    };

    return (
        <main>
            <div className="main__container">
                <div className="main__tile_heading cus-btn-include-sec">
                    Order Picking Plan
                    <div className="pickHead mb-3 pl-3 pr-3 pt-3 zIndex2">
                        <div></div>
                        <div className="pickHead">
                            <div className="fontFix">
                                <DatePickerComponent
                                    dateField={filterData.startDate}
                                    handleDateChange={(date) => handleDateChange(date)}
                                    fieldName="ValidFrom"
                                    dateFormat="MM-dd-yyyy"
                                    showFutureDate={false}
                                />
                            </div>

                            <button disabled={!packingLabels.filter(item => item.isChecked).length} className="btn cus-seconday-bg-btn showHideFilter ml-2" onClick={handleMultiUpdate}>
                                <i className="fa fa-print" aria-hidden="true"></i> Marked As Picked
                            </button>
                        </div>
                    </div>
                </div>
                {loader && (<div className="full-screen-spinner-overlay"><LoaderSpinner data-testid="loader-spinner" /></div>)}
                <div className="main_content_table_history">
                    <div className="tableFixHead pl-2 zIndex1">
                        {/* <CollapsibleGroupedTable data={packingLabels} groupBy={'CompanySellerName'} /> */}


                        {shippedLabelHistoryStatus === 'SUCCESS' && (
                            <DataTable
                                headers={ShippedLabelHistoryColumns}
                                tableData={packingLabels}
                                actionType={6}
                                handleAction={handleAction}
                                handleSortingColumn={handleSortingColumn}
                                tableDataStatus={shippedLabelHistoryStatus}
                                filterData={filterData}
                                handleCheckRecord={handleCheckRecord}
                                isSelectAll={packingLabels?.filter(item => item.isChecked).length === packingLabels.length}
                            />
                        )}
                    </div>
                </div>
                <BatchPagination
                    gridData={packingLabels}
                    totalVisualRecords={packingLabels?.length}
                    numberOfPage={filterData.pageSize}
                    numOfPage={numOfPage}
                    loader={loader}
                    currentPage={filterData.pageIndex}
                    totalPages={filterData.totalPages}
                    totalRecords={shippedLabelHistory?.TotalRecords || 0}
                    setCurrentPage={(value) => setfilterData({ ...filterData, pageIndex: value })}
                    setNumberOfPage={(value) => setfilterData({ ...filterData, pageSize: value })}
                />
            </div>
        </main>

    );
}

export default ShippedLabelHistory;